import React from 'react';
import { Link, useLocation, useHistory } from "react-router-dom";
import './navbar.scss';
import LogoImg from '../../assets/navbar/logo192.png';

const DesktopNav = (props) => {
  const location = useLocation();
  const history = useHistory();

  const handleLogoClick = () => {
    history.push('/');
  };

  return (
    <nav className={`Navbar ${!props.userIsScrolled ? "extraLargeNavbar" : ""}`}>
      <div className="wrapper flex-s-between">
        <div>
          <img
            src={LogoImg}
            alt="logo"
            className="pointer"
            style={{ height: '80px' }}
            onClick={handleLogoClick}
          />
        </div>
        <div className="nav-buttons">
          {location.pathname !== '/' && (
            <button className='button-link' style={{marginRight:"10px"}} onClick={() => history.push('/')}>Home</button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default DesktopNav;